import clsx from "clsx"
import { useTranslation } from "react-i18next"
import styles from "./Spinner.module.css"

export const Spinner = (props: { size?: number; className?: string }) => {
	const { t } = useTranslation("components")
	const size = props.size || 44

	return (
		<span
			role="status"
			aria-label={t("spinner.ariaLoading")}
			className={clsx(styles.spinner, props.className)}
			style={{ width: size, height: size }}
		>
			<svg className="w-full" viewBox="22 22 44 44">
				<circle
					cx="44"
					cy="44"
					r="20.2"
					fill="none"
					strokeWidth="3.6"
					strokeLinecap="round"
					stroke="currentColor"
				></circle>
			</svg>
		</span>
	)
}
